import { render, staticRenderFns } from "./DisputeNotif.vue?vue&type=template&id=1447b1ee&"
import script from "./DisputeNotif.vue?vue&type=script&lang=js&"
export * from "./DisputeNotif.vue?vue&type=script&lang=js&"
import style0 from "./DisputeNotif.vue?vue&type=style&index=0&id=1447b1ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports